<template>
  <div>
    <div id="hmobile">
      <div style="width: 100%;height: 150px;">
        <img style="width: 100%;height: 100%;" src="../assets/img/tout/guanc.jpg">
      </div>
      <div style="margin: auto 10px;text-align: initial;">
        <el-row>
         <el-col :span="12" v-for="(item, index) in tableData" :key="index">
           <router-link tag="div" :to="{path:'/collection/ceramics',query:{id:item.tid,title:item.name}}" class="grid-content bg-purple">
             <div class="gc-recli">
               <img style="width: 100%;" :src="item.image" />
               <span>{{item.name}}</span>
             </div>
           </router-link>
         </el-col>
        </el-row>
      </div>
    </div>
    <div id="hpc">
      <div id="lbimg"><img style="width: 100%;height: 100%;" src="../assets/img/tout/guanc.jpg"></div>
      <div style="margin: auto 15%;text-align: initial;">
        <el-row>
          <el-col :span="6" v-for="(item, index) in tableData" :key="index">
            <router-link tag="div" :to="{path:'/collection/ceramics',query:{id:item.tid,title:item.name}}" class="grid-content bg-purple">
              <div class="gc-recli">
                <img style="width: 100%;" :src="item.image" />
                <span>{{item.name}}</span>
              </div>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        pageTotal: [],
        currentPage: 1,
        pageSize: 100,
        pageNum: 1,
        tableData: []
      }
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSearch() {
        let eWidth = document.body.clientWidth;
        document.getElementById("hpc").style.width = eWidth + "px";
        this.search();
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.search();
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/relic-exhibition/relicExhibitionAll?pageNumber=' + this.pageNum + '&pageSize=' +
          this.pageSize +
          '';
        that.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.tableData = cData.data.list;
        }).catch(function(error) {
          console.log(err);
        })
      },
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("hmobile").style.display = "block";
      } else {
        document.getElementById("hpc").style.display = "block";
      };
      this.handleSearch();
      $("body,html").animate({
        scrollTop: 0
      }, 1);
    }
  }
</script>

<style scoped>
  .grid-content {
    text-align: center;
  }

  .gc-recli {
    position: relative;
    overflow: hidden;
    display: inline-block;
    margin: 20px;
    cursor: pointer;
  }

  .gc-recli>img {
    width: 100%;
    transform: scale3d(1, 1, 1);
    transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
  }

  .gc-recli>img:hover {
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
    height: 100%;
    transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
  }

  .gc-recli>span {
    position: absolute;
    height: 50px;
    width: 100%;
    background: hsla(0, 0%, 40%, .8);
    z-index: 9999;
    bottom: 0;
    left: 0;
    line-height: 50px;
    font-size: 1.3em;
    color: #fff;
  }

  #hpc {
    display: none;
    background: rgba(255, 255, 255, 0.6);
  }

  #lbimg {
    margin-bottom: 50px;
  }

  p {
    margin: 0;
  }

  #defdl {
    width: 60%;
    height: 30px;
    margin: 20px 20%;
    background: #FF9900;
    line-height: 30px;
    cursor: pointer;
    color: #ffffff;
  }

  #defdl:hover {
    background: #FF0000;
  }

  #Clist {
    margin: 0 auto;
  }

  #Clist_one {
    margin: 0 auto;
  }

  #Clist_tow {
    margin: 30px auto;
  }

  #Clist_one>div,
  #Clist_tow>div {
    float: left;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    cursor: pointer;
  }

  #Clist_one>div>img {
    width: 100%;
    height: 100%;
    transform: scale3d(1, 1, 1);
    transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
  }

  #Clist_one>div>img:hover {
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
    height: 100%;
    transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
  }

  #Clist_one>div>span {
    position: absolute;
    height: 50px;
    width: 100%;
    background: rgb(102, 102, 102, 0.8);
    z-index: 9999;
    bottom: 0;
    left: 0;
    line-height: 50px;
    font-size: 1.3em;
    color: white;
  }

  #Clist_tow>div>img {
    width: 100%;
    height: 100%;
    transform: scale3d(1, 1, 1);
    transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;
  }

  #Clist_tow>div>img:hover {
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
    height: 100%;
    transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
    -webkit-transition: all 1s cubic-bezier(0, 1, 1, 1) 0s;
  }

  #Clist_tow>div>span {
    position: absolute;
    height: 50px;
    width: 100%;
    background: rgb(102, 102, 102, 0.8);
    z-index: 9999;
    bottom: 0;
    left: 0;
    line-height: 50px;
    font-size: 1.3em;
    color: white;
  }

  /*mobile*/

  #hmobile {
    display: none;
    background: rgba(255, 255, 255, 0.6);
  }

  #mlbimg {
    margin-bottom: 50px;
  }

  #mdefdl {
    width: 60%;
    height: 30px;
    margin: 20px 20%;
    background: #FF9900;
    line-height: 30px;
    cursor: pointer;
    color: #ffffff;
  }

  #mdefdl:hover {
    background: #FF0000;
  }

  #mClist {
    margin: 0 auto;
  }

  #mClist_one {
    margin: 0 auto;
  }

  #mClist_one>div:nth-child(1),
  #mClist_one>div:nth-child(3),
  #mClist_tow>div:nth-child(1),
  #mClist_tow>div:nth-child(3) {
    width: 45%;
    float: left;
    position: relative;
    margin-top: 20px;
  }

  #mClist_one>div:nth-child(2),
  #mClist_one>div:nth-child(4),
  #mClist_tow>div:nth-child(2),
  #mClist_tow>div:nth-child(4) {
    margin-left: 10%;
    width: 45%;
    float: left;
    position: relative;
    margin-top: 20px;
  }

  #mClist_one>div>span,
  #mClist_tow>div>span {
    position: absolute;
    bottom: 0;
    left: 0;
    background: rgba(149, 111, 23, 0.5);
    color: rgb(255, 255, 255);
    width: 100%;
  }

  #mClist_one>div>img,
  #mClist_tow>div>img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Collection.vue